import React from 'react';
import { cn } from '../../lib/cn';

export function TableScroller({ className, ...rest }) {
  return <div className={cn('overflow-auto', className)} {...rest} />;
}

export function Table({ className, ...rest }) {
  return <table className={cn('w-full text-sm border-separate border-spacing-0', className)} {...rest} />;
}

export function THead({ className, ...rest }) {
  return <thead className={cn('bg-slate-50/95 backdrop-blur sticky top-0 z-10', className)} {...rest} />;
}

export function TBody({ className, ...rest }) {
  return <tbody className={className} {...rest} />;
}

export function TH({ sortable = false, className, children, ...rest }) {
  return (
    <th
      className={cn(
        'text-[11px] font-semibold text-slate-500 uppercase tracking-wider px-3 py-2.5 border-b border-slate-200 text-left whitespace-nowrap',
        sortable && 'cursor-pointer select-none hover:bg-slate-100/80 hover:text-slate-700',
        className
      )}
      {...rest}
    >
      {children}
    </th>
  );
}

export function TR({ hoverable = true, selected = false, className, ...rest }) {
  return (
    <tr
      className={cn(
        'transition-colors duration-100',
        hoverable && 'hover:bg-slate-50/70',
        selected && 'bg-brand-50/40',
        className
      )}
      {...rest}
    />
  );
}

export function TD({ className, ...rest }) {
  return (
    <td className={cn('px-3 py-2.5 border-b border-slate-100 text-slate-700 align-middle', className)} {...rest} />
  );
}
